import type { CategoriaAlteracao } from "@/modules/recursos/simulacao";

import type { EstadoTagDetalhe } from "./types-detalhe-simulacao-dialog";

export const CATEGORIAS: readonly CategoriaAlteracao[] = ["profissional", "fornecedor", "local"];

export const CARREGANDO_LABEL = "Carregando simulação...";
export const TITULO_ALTERACOES = "Alterações incluídas";
export const SEM_ITENS_TEXTO = "Nenhuma alteração registrada nesta simulação.";

/** Tag de estado do cartão (Figma 10899:2536, 10899:2542, 10899:2548). */
export const ESTADO_TAG_PADRAO: Pick<EstadoTagDetalhe, "icone" | "severity"> = {
  icone: "pi pi-clock",
  severity: "secondary",
};

export const ESTADO_TAG: Record<string, Pick<EstadoTagDetalhe, "icone" | "severity">> = {
  pendente: ESTADO_TAG_PADRAO,
  aplicada: { icone: "pi pi-check", severity: "success" },
  "aplicada-com-aviso": { icone: "pi pi-exclamation-triangle", severity: "warning" },
  "nao-aplicada": { icone: "pi pi-times-circle", severity: "danger" },
  descartada: { icone: "pi pi-ban", severity: "secondary" },
};
